export enum PersonalChangeType {
  ChangeFail,
  ChangeSuccess,
  Changing,
  Unchanged,
}

export enum IsReadChange {
  UnRead,
  HaveRead,
}
